
export default {
    data() {
        return { user: {} }
    },
    methods: {
        setUser(userStatus) {
            if (userStatus) {
                if (userStatus.userLoggedIn && !userStatus.isGuest) {
                    this.user = true;
                    return
                }
            }
            this.user = false;
        },
        fetchUserStatus() {
            fetch(  '/myinterfaces/sky/userstatus' )
                .then( (response) => response.json() )
                .then(json => this.setUser( json ));
        }
    },
    mounted() {
        this.fetchUserStatus();
    },
}